import { render, staticRenderFns } from "./inline_draft_comment_row.vue?vue&type=template&id=f5c1d9a0&"
import script from "./inline_draft_comment_row.vue?vue&type=script&lang=js&"
export * from "./inline_draft_comment_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "inline_draft_comment_row.vue"
export default component.exports